import { useMemo } from 'react';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
export function useSendReminder() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const { t: reminderTexts } = useLocaleKeys('hooks.useSendReminder');
    const { showSuccessToast, showErrorToast } = useOverlayContext();
    async function sendReminder(agreement) {
        const result = await handlePromise(api.relationship.sendProposalApprovalReminder(agreement.id));
        if (result.success) {
            showSuccessToast(reminderTexts.reminderSent());
        } else {
            showErrorToast(commonTexts.toasts.failedToSendReminder());
        }
    }
    return useMemo(()=>({
            sendReminder
        }), []);
}
